/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewJobService {
  public get baseUrl(): string {
    return `${this.dataCollectorService.baseurl()}`;
  };
  get newJobAPIurls(): any{
      return {
      jobCategoryUrl: `${this.baseUrl}/jobs/category`,
      customerUrl: `${this.baseUrl}/customers`,
      organizationUrl: `${this.baseUrl}/organization`,
      propertyUrl: `${this.baseUrl}/property`,
      userUrl: `${this.baseUrl}/user/all`,
      jobsUrl: `${this.baseUrl}/jobs`,
      holidayUrl: `${this.baseUrl}/company/holidays`
    }
  };
  get scheduleOverlapUrl(): string{
    return `${this.baseUrl}/jobs/schedule/overlap`;
  };

  constructor(
    private dataCollectorService: DataCollectorService,
    private utilityService: UtilityService) { }


  isDateConflict(startDateTimeOne: any, endDateTimeOne: any, startDateTimeTwo: any, endDateTimeTwo: any): boolean {
    if (moment(startDateTimeTwo).isBetween(moment(startDateTimeOne), moment(endDateTimeOne), undefined, '[)') ||
      moment(endDateTimeTwo).isBetween(moment(startDateTimeOne), moment(endDateTimeOne), undefined, '(]') ||
      (moment(startDateTimeTwo).isBefore(moment(startDateTimeOne)) && moment(endDateTimeTwo).isAfter(moment(endDateTimeOne)))) {
      return true;
    }
    return false;
  }

  getBusinessHours(type: string): any {
    const companyConfig: any = this.utilityService.companyConfig;
    if (type === 'start') {
      return companyConfig?.business_hours?.start_time || '00:00:00';
    } else if (type === 'end') {
      return companyConfig?.business_hours?.end_time || '24:00:00';
    }
    return null;
  }

  getUserWorkHours(userUid: string): Promise<any> {
    if(userUid) {
      const workHourUrl = `${this.baseUrl}/user/${userUid}/work_hours`;
      return this.dataCollectorService.getData(workHourUrl).pipe(map((response: any) => response?.data || [])).toPromise();
    }
  }
}
